import { handleResponse } from './handleResponse'
import store from '../store'
import { history } from '../entry'
import { localLogoutUser } from '../reducers/auth/currentUser.actions'

/**
 * fetchingAPI is a wrapper for Balto APIs.
 *
 * It grabs the user data from local storage and passes it into the headers, then handles the
 * response in a separate function.
 *
 * We should not be pulling from local storage, but rather from Redux or API interceptors.
 *
 * @param {string} url The full API endpoint URL
 * @param {string} method One of GET, POST, PUT, PATCH, DELETE
 * @param {Function} dispatch The Redux dispatch method
 * @param {Object} body Optional body for POST, PUT, PATCH requests
 * @param {Function} callback Optional callback function
 * @param {*} details An optional details object for modifying the response handler
 * @param {Boolean} useOwnOrganizationID Whether to set organizationid header to user's org id (as opposed to org id user may be viewing)
 * @param signal
 * @param setContentType An optional boolean to enable/disable setting content type
 * @returns {Promise} Returns a promise that either resolves or rejects based on the response code
 */
export const fetchingAPI = (
  url,
  method,
  dispatch,
  body,
  callback,
  details = {},
  useOwnOrganizationID,
  signal,
  setContentType = true
) => {
  const state = store.getState()
  const { username, organizationid, token, own_organization_id } = state.currentUser

  // If no token exists, don't attempt to hit the endpoint because it will always fail
  if (!token) {
    console.info('Token not found. Logging out user.')
    dispatch(localLogoutUser({ history }))
  }

  return fetch(url, {
    method,
    body,
    headers: {
      ...(setContentType && { 'Content-Type': 'application/json' }),
      'auth-type': 'web',
      username,
      organizationid: useOwnOrganizationID ? own_organization_id : organizationid,
      token,
    },
    signal,
  }).then((response) => handleResponse(response, dispatch, callback, details))
}

// NOTE: unlike fetchingAPI, this returns the raw response and leaves handling the response to the caller
export const fetchingAPIWithPendingToken = (url, method, dispatch, body) => {
  const state = store.getState()
  const { pendingToken, organizationID, username } = state.mfa

  // If no pendingToken exists, don't attempt to hit the endpoint because it will always fail
  if (!pendingToken) {
    console.info('Pending token not found. Logging out user.')
    dispatch(localLogoutUser({ history }))
  }

  return fetch(url, {
    method,
    body,
    headers: {
      'auth-type': 'web',
      'Content-Type': 'application/json',
      username,
      organizationID,
      pendingToken,
    },
  })
}
